
import { useConnectionState } from './useConnectionState';
import { createTablesIfNotExist } from '@/lib/supabase';
import { useToast } from '@/hooks/use-toast';
import { useCallback } from 'react';

/**
 * Enhanced hook to manage Supabase connection status with improved reliability
 */
export const useAdminConnection = () => {
  const { toast } = useToast();
  const { 
    status: connectionStatus, 
    filteredStatus,
    checkConnection: checkConnectionState,
    isConnected
  } = useConnectionState(true, 60000); // Auto-check every minute
  
  // Enhanced connection check with table creation
  const checkConnection = useCallback(async () => {
    const connected = await checkConnectionState(true);
    
    if (connected) {
      // Try to create tables if they don't exist
      try {
        await createTablesIfNotExist();
      } catch (error) {
        console.error('Error creating tables:', error);
        
        toast({
          title: "Lỗi cơ sở dữ liệu",
          description: "Đã kết nối thành công nhưng gặp lỗi cấu trúc dữ liệu.",
          variant: "destructive"
        });
      }
    }
    
    return connected;
  }, [checkConnectionState, toast]);
  
  return {
    connectionStatus: filteredStatus, // Use filtered status that excludes 'unknown'
    isConnected,
    checkConnection
  };
};
